module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("Modal")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui bottom button",
    on: {
      "click": function($event) {
        _vm.changeModalStatus('showLongModal', true)
      }
    }
  }, [_c('span', [_vm._v("Try standard modal")])]), _vm._v(" "), _c('div', {
    staticClass: "ui bottom button",
    on: {
      "click": function($event) {
        _vm.changeModalStatus('showBasicModal', true)
      }
    }
  }, [_c('span', [_vm._v("Try basic modal")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("Note that you'll need provide a var to control the visibility of modal and configure the tree base parts of modal: header, content, actions")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    staticClass: "ui header"
  }, [_vm._v("Props")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('modal', {
    attrs: {
      "modalId": "basic-modal",
      "type": "basic",
      "showModal": _vm.showBasicModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showBasicModal = $event
      }
    }
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("Hello, i'm header")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("Hello, i'm content")]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("Hello, i'm footer")])]), _vm._v(" "), _c('modal', {
    attrs: {
      "modalId": "long-modal",
      "showModal": _vm.showLongModal
    },
    on: {
      "update:showModal": function($event) {
        _vm.showLongModal = $event
      }
    }
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("Hello, i'm header")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("Hello, i'm content")]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_vm._v("Hello, i'm footer")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Modal component,\n    "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/modal.html"
    }
  }, [_vm._v(" you can see all documentation here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('pre', [_vm._v("\n        import { Modal } from 'semvue';\n\n        export default {\n          name: 'ModalDoc',\n          components: {\n            Modal,\n          },\n        }\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('pre', [_vm._v("\n      <modal modalId=\"modal1\" type=\"basic\" :showModal.sync=\"showBasicModal\">\n        <div slot=\"header\">Hello, i'm header</div>\n        <div slot=\"content\">Hello, i'm content</div>\n        <div slot=\"footer\">Hello, i'm footer</div>\n      </modal>\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui definition table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("modalId")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Is a div id for modal")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("showModal")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Used to control modal visibility")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty (standard modal)")]), _vm._v(" "), _c('td', [_vm._v("The type of modal.\n          "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/modal.html"
    }
  }, [_vm._v(" You can see all types here")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("closeable")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("Used to define if should closed with any click out of modal or force user to take some action")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("Object empty")]), _vm._v(" "), _c('td', [_vm._v("Overrides component options."), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/modal.html"
    }
  }, [_vm._v(" You can see all options here")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49738963"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalDoc.vue
// module id = 146
// module chunks = 1